import { tabindexClearDirective } from '@utils/directives';

export default ({ app }) => {
  app.use(tabindexClearDirective);
};
